const Mascot = ({ size = 44, className = "" }) => (
  <img
    src="/brand/emblem.png"
    width={size}
    height={size}
    className={className}
    alt="Aardvarks Vault emblem — vault door with AV monogram"
    data-testid="mascot-mark"
  />
);

export default Mascot;
